import { TractNRI } from 'components/nri-table';
import { SlotInterestInfo } from '../nri/slot-interest-info';
import styles from './slot-list.module.scss';
import classNames from 'classnames';

export interface FutureSlot {
  id: string;
  slotRef?: string;
  formation?: string;
  typeCurveStatus?: string;
}

// Slot list for Future Development. Renders LTD slots with optional
// NRI Interest Info cards when slotNriByUwi is provided.
export const FutureSlotList = ({
  slots,
  selectedSlotId,
  setSelectedSlotId,
  slotNriByUwi,
}: {
  slots: FutureSlot[];
  selectedSlotId: string | undefined;
  setSelectedSlotId: (slotId: string) => void;
  slotNriByUwi?: Map<string, TractNRI>;
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.stickyHeader}>
        <h4 className={styles.title}>Slots</h4>
      </div>
      <div className={styles.scrollableContent}>
        {slots.map((slot) => {
          const nriData = slotNriByUwi?.get(slot.id);

          return (
            <div
              key={slot.id}
              onClick={() => setSelectedSlotId(slot.id)}
              className={classNames(styles.slotCard, {
                [styles.selected]: slot.id === selectedSlotId,
              })}
            >
              <div className={styles.slotLeft}>
                <div className={styles.slotHeader}>
                  <span className={styles.slotLink}>
                    {slot.slotRef ?? '--'}
                  </span>
                </div>
                <div className={styles.slotMeta}>
                  <div>Formation: {slot.formation ?? '--'}</div>
                  <div>{slot.typeCurveStatus ?? '--'}</div>
                </div>
              </div>
              {nriData && (
                <div className={styles.slotRight}>
                  <SlotInterestInfo
                    slotNri={nriData.totalSlotNri ?? null}
                    slotWi={nriData.totalSlotWi ?? null}
                    subtracts={nriData.subtracts ?? []}
                    tractId={nriData.crmTractSalesforceId ?? ''}
                    slotId={nriData.slotId ?? slot.id}
                    wellUwi={nriData.wellId || null}
                    wellName={nriData.wellName || slot.slotRef || null}
                    hasUats={true}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
